import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AnswerPage.scss';
const quizData = [
	{
		no: 1,
		type: 1,
		title: '두 아이 중 후이를 선택해주세요!',
		picture: '/assets/q2.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '2',
		explanation:
			'이 사진에서 루이와 후이를 구분하는 방법은 콧잔등을 확인해야 해요!\n루이의 콧잔등은 가마가 2개이고, 후이의 콧잔등 가마는 1개에요!',
	},
	{
		no: 2,
		type: 1,
		title: '대나무를 먹는 귀여운 아이, 둘 중 루이는 누구일까요?',
		picture: '/assets/q5.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '2',
		explanation:
			'이 사진에서 루이와 후이를 구분하는 방법은 음식 먹을 때의 자세를 봐야해요!\n루이는 푸바오처럼 누워서 먹는 걸 좋아하고, 후이는 앉아서 먹는 편이에요~',
	},
	{
		no: 3,
		type: 1,
		title: '두 아이 중 루이를 선택해주세요!',
		picture: '/assets/q1.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '2',
		explanation:
			'이 사진에서 루이와 후이를 구분하는 법은 루이와 후이의 눈에 쓴 선글라스를 봐야해요!\n후이의 경우 눈 모양이 하트 모양에 가깝고, 루이의 경우 타원 모양에 가까워요!',
	},
	{
		no: 4,
		type: 1,
		title: '귀여운 후이와 루이의 뒷모습! 누가 후이일까요?',
		picture: '/assets/q3.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '1',
		explanation:
			'이 사진에서 루이와 후이를 구분하는 법은 검은색 볼레로(등무늬)를 잘 봐야해요!\n루이의 볼레로는 넓은 V 모양이고, 후이의 볼레로는 좁은 U 모양에 가까워요!',
	},
	{
		no: 5,
		type: 1,
		title: '겹쳐 누워 있는 후이와 루이 중 루이는 누구일까요?',
		picture: '/assets/q4.webp',
		button1: '위쪽',
		button2: '아래쪽',
		answer: '1',
		explanation:
			'이 사진에서 루이와 후이 구분법은 정수리를 유심히 봐야해요!\n후이의 정수리는 조금 더 둥근편이고, 루이는 정수리가 조금 뾰족한 편이에요!',
	},
	{
		no: 6,
		type: 1,
		title: '쌍둥바오의 이름 뜻 찾아내기',
		picture: '/assets/q8.webp',
		button1: '루이바오 - 슬기로운 보물\n후이바오 - 빛나는 보물',
		button2: '후이바오 - 슬기로운 보물\n루이바오 - 빛나는 보물',
		answer: '1',
		explanation:
			'루이바오(睿寶) - 슬기로운 보물, 후이바오(輝寶) - 빛나는 보물\n\n루이바오와 후이바오의 이름 뜻은 한자를 확인하면 맞출 수 있어요\n루이는 (睿寶) ‘슬기 예’, ‘보배 보’이고, 후이(輝寶)는 ‘빛날 휘’, ‘보배 보’ 입니다!',
	},
	{
		no: 7,
		type: 1,
		title: '자리 경쟁 중인 루이와 후이, 둘 중 루이는 누구일까요?',
		picture: '/assets/q7.png',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '1',
		explanation:
			'이 사진에서 루이와 후이를 구분하는 방법은 다리 길이를 비교하는 거에요!\n루이는 후이보다 다리 길이가 긴 편이고, 후이는 다리가 짧으면서 더 통통한 편이에요!',
	},
	{
		no: 8,
		type: 1,
		title: '유채밭에 숨어있는 판다는 누구일까요?',
		picture: '/assets/q17.webp',
		button1: '루이바오',
		button2: '후이바오',
		answer: '2',
		explanation:
			'에피소드 문제입니다! 루야 후야 임오 삼춘이라면 에피소드를 다 봤을 거라 생각했어요!\n마지막 문제에서 루이와 후이를 구분하기 위해서는 ‘말하는동물원 뿌빠TV’ 유튜브에서 유채밭 판다 에피소드를 참고하세요!',
	},
];

const AnswerPage = () => {
	const navigate = useNavigate();
	const handleStartClick = () => {
		navigate('/');
		window.scrollTo(0, 0); // /quiz 경로로 이동
	};
	const handleBackClick = () => {
		navigate(-1);
		window.scrollTo(0, 0); // 이전 페이지로 이동
	};

	return (
		<div className="answer-container">
			<div className="alert">
				<span>※ 사진 각도에 따라 구분법이 조금 다를 수 있어요!</span>
			</div>
			{quizData.map((quiz, index) => (
				<div key={index} className="answer-item">
					<div className="answer-head">
						<div className="answer-head-info">
							<div className="answer-head-info-num">Q.{quiz.no}</div>
							<h3 className="answer-head-title">{quiz.title}</h3>
						</div>
					</div>
					<div
						className="answer-content"
						style={{ backgroundImage: `url(${quiz.picture})` }}
					></div>
					<div className="answer-explanation">
						<div className="answer-explanation-title">✍🏻 해설</div>

						<div className="answer-explanation-detail">{quiz.explanation}</div>
					</div>
				</div>
			))}
			<div className="button-wrapper">
				{' '}
				<button className="result-button" onClick={handleStartClick}>
					테스트 다시하기
				</button>
				{/* <button className="result-button" onClick={handleStartClick2}>
					마라맛 테스트 다시하기
				</button> */}
				<button className="back-button" onClick={handleBackClick}>
					뒤로가기
				</button>
			</div>
		</div>
	);
};

export default AnswerPage;
